'use client';

import { useCallback, useState } from 'react';
import { useDocumentEvent } from '@/hooks/useDocumentEvent';

type HydrateOnInteractionOptions = {
  enabled?: boolean;
  includeKeydown?: boolean;
};

export function useHydrateOnInteraction(options: HydrateOnInteractionOptions = {}) {
  const { enabled = true, includeKeydown = true } = options;
  const [hasInteracted, setHasInteracted] = useState(false);

  const markInteracted = useCallback(() => {
    setHasInteracted(true);
  }, []);

  const shouldListen = enabled && !hasInteracted;

  useDocumentEvent('pointerdown', markInteracted, { passive: true }, shouldListen);
  useDocumentEvent('touchstart', markInteracted, { passive: true }, shouldListen);
  useDocumentEvent('wheel', markInteracted, { passive: true }, shouldListen);
  useDocumentEvent('focusin', markInteracted, { passive: true }, shouldListen);
  useDocumentEvent('keydown', markInteracted, undefined, shouldListen && includeKeydown);

  return { hasInteracted, markInteracted };
}
